import { easyPost } from './utils';

// 交叉落地页优惠券列表
// eslint-disable-next-line
export const collectCoupons = easyPost('cross.prize.list');

// 交叉落地页优惠券领券
export const prizeAward = easyPost('cross.prize.award');
